import { apiClient } from './client'

export interface UserNotification {
  id: string
  title: string
  body_markdown: string
  image_url: string | null
  is_important: boolean
  is_deleted: boolean
  created_at?: string | null
  updated_at?: string | null
  target_shop_ids?: string[]
  is_read: boolean
  was_popup_shown: boolean
  read_at?: string | null
  popup_shown_at?: string | null
}

export interface UserUnreadNotificationsResponse {
  items: UserNotification[]
  unread_count: number
  server_time: string
}

export interface NotificationStateResponse {
  notification_id: string
  is_read: boolean
  was_popup_shown: boolean
  read_at?: string | null
  popup_shown_at?: string | null
}

export const notificationsApi = {
  getUnread: async (params?: { updated_after?: string; limit?: number }) => {
    const { data } = await apiClient.get<UserUnreadNotificationsResponse>(
      '/api/v1/notifications/unread',
      { params }
    )
    return data
  },

  markRead: async (notificationId: string) => {
    const { data } = await apiClient.post<NotificationStateResponse>(
      `/api/v1/notifications/${notificationId}/read`
    )
    return data
  },

  markPopupShown: async (notificationId: string) => {
    const { data } = await apiClient.post<NotificationStateResponse>(
      `/api/v1/notifications/${notificationId}/popup-shown`
    )
    return data
  },
}
